<div class="container-fluid">
    <div class="row page_card__wide">
        <div class="col-12" *kaHasRoles="[permission.apparatoassetmodelflowWrite]; checkRealm: true">
            <button type="button" class="btn btn-light btn-sm d-flex align-items-center ms-auto" (click)="pairModal()">
                <span class="material-symbols-outlined text-primary">p2p</span> Associa
            </button>
        </div>

        <ng-template [spinnerLoader]="deleteSubscription && !deleteSubscription.closed"></ng-template>
 
        <div class="col" [spinnerLoader]="deviceFlowResource.isLoading()">
            <div class="table-responsive">
                <table class="table align-middle">
                    <thead>
                        <tr>
                            <th scope="col">Marca</th>
                            <th scope="col">Modello</th>
                            <th scope="col">Tipo asset</th>
                            <th scope="col">Descrizione</th>
                            <th scope="col" *kaHasRoles="[permission.apparatoassetmodelflowWrite]; checkRealm: true"></th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (item of deviceFlowResource.value()?.content; track $index) {
                            <tr>
                                <td>{{ item.assetModel.assetVendor.name }}</td>
                                <td>{{ item.assetModel.name }}</td>
                                <td>{{ item.assetModel.assetType.name }}</td>
                                <td>{{ item.description }}</td>
                                <td *kaHasRoles="[permission.apparatoassetmodelflowWrite]; checkRealm: true" class="text-end">
                                    <button type="button" class="btn btn-sm btn-light" (click)="cancelPair(item)" ngbTooltip="Disassocia">
                                        <span class="material-symbols-outlined text-primary">mobile_cancel</span>
                                    </button>
                                </td>
                            </tr>
                        } @empty {
                            <tr>
                                <td colspan="5" class="text-center">Nessun risultato</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
